import { AdvertisingCmsInt } from "@app/interfaces/advertising.interface";
import {DestinationsRespInt} from "@interfaces/*";
import {DestinationModel} from "@app/models";

export class AdvertisingMapper {
  constructor() {
  }

  idlesDTOtoData(data:AdvertisingCmsInt): AdvertisingCmsInt {
    let advertising = {};
    if (data) {
      advertising = this.parseJsonCMS(data);

      if (!advertising) {
        return {};
      }
    }
    return advertising;
  }

  parseJsonCMS(Json) {
    let result = {};
    let itemExists = {}
    const isArrayJson = Array.isArray(Json) ? Json : []
    for (let item of isArrayJson) {
      if(item.itemsSlider) {
        for (let subItem of item.itemsSlider) {
          if(subItem.language){
            if (!result[subItem.language.slice(0, 2)]) {
              result[subItem.language.slice(0, 2)] = [];
            }
            itemExists = result[subItem.language.slice(0, 2)].find(item => item.nid === subItem.nid);
            if (!itemExists) {
              result[subItem.language.slice(0, 2)].push(subItem)
            }
          }
        }
      }
    }
    return result
  }

  parseJsonCMSNew(Json) {
    let result = {};
    let itemExists = {}
    const isArrayJson = Array.isArray(Json) ? Json : []
    for (let item of isArrayJson) {
      if(item.itemsSlider) {
        for (let subItem of item.itemsSlider) {
          if(subItem.language){
            if (!result[subItem.language.slice(0, 2)]) {
              result[subItem.language.slice(0, 2)] = [];
            }
            itemExists = result[subItem.language.slice(0, 2)].find(item => item.nid === subItem.nid);
            if (!itemExists) {
              result[subItem.language.slice(0, 2)].push(subItem)
            }
          }
        }
      }
    }
    return result
  }
  mapperAriportJSON(data: DestinationsRespInt) {
    const response = [] ;
    for (const [key, value] of Object.entries(data)) {
      response.push(new DestinationModel(value));
    }
    return response;
  }

}
